module.exports = __webpack_public_path__ + "img/SKMJ_sheet3.51b039aa.png";